export default __webpack_public_path__ + "static/media/pl_nurse2.a2b7ac80.png";